var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileAos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#262626"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.23 14.8502V20.6602C11.23 20.9102 11.43 21.1102 11.68 21.1102H12.51V23.2602C12.51 23.9202 13.05 24.4602 13.71 24.4602C14.37 24.4602 14.91 23.9202 14.91 23.2602V21.1102H17.09V23.2602C17.09 23.9202 17.63 24.4602 18.29 24.4602C18.95 24.4602 19.49 23.9202 19.49 23.2602V21.1102H20.32C20.57 21.1102 20.77 20.9102 20.77 20.6602V14.8502H11.23Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.77 14.8502H22.86C23.35 14.8502 23.75 15.2502 23.75 15.7402V18.7702C23.75 19.3202 23.31 19.7602 22.76 19.7602C22.21 19.7602 21.77 19.3202 21.77 18.7702V14.8502Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24 19.7602C8.69 19.7602 8.25 19.3202 8.25 18.7702V15.7402C8.25 15.2502 8.65 14.8502 9.14 14.8502H10.23V18.7702C10.23 19.3202 9.79 19.7602 9.24 19.7602Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6 7.63024C20.39 7.47024 20.09 7.51024 19.94 7.72024L18.78 9.25024C18.02 8.64024 17.06 8.26024 16.01 8.26024C14.96 8.26024 14 8.64024 13.24 9.25024L12.08 7.72024C11.92 7.51024 11.62 7.47024 11.42 7.63024C11.21 7.79024 11.17 8.08024 11.33 8.29024L12.55 9.92024C11.93 10.6902 11.54 11.6502 11.54 12.7202V13.2702C11.54 13.6002 11.81 13.8502 12.12 13.8502H19.88C20.21 13.8502 20.46 13.5902 20.46 13.2702V12.7202C20.46 11.6502 20.08 10.7002 19.45 9.92024L20.69 8.29024C20.85 8.08024 20.8 7.78024 20.6 7.63024ZM14.06 11.8702C13.79 11.8702 13.57 11.6502 13.57 11.3802C13.57 11.1102 13.79 10.8902 14.06 10.8902C14.33 10.8902 14.55 11.1002 14.55 11.3802C14.55 11.6602 14.34 11.8702 14.06 11.8702ZM17.93 11.8702C17.66 11.8702 17.44 11.6502 17.44 11.3802C17.44 11.1102 17.66 10.8902 17.93 10.8902C18.2 10.8902 18.42 11.1002 18.42 11.3802C18.42 11.6602 18.2 11.8702 17.93 11.8702Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileAos);
export default __webpack_public_path__ + "static/media/profile_AOS.35eccbc4989ab6deea1799ea1ed6b8de.svg";
export { ForwardRef as ReactComponent };